import React, { Suspense, lazy } from "react";

const CourseIconRenderer = lazy(() =>
  import("./CourseIconRenderer")
);

export default function CourseIcon({
  iconSlot = null,
  legacyIconKey = null,
  className = "",
  ...fontAwesomeProps
}) {
  if (
    (iconSlot === null || iconSlot === undefined) &&
    !legacyIconKey
  ) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <span
          className={className}
          aria-hidden={fontAwesomeProps["aria-label"] ? undefined : true}
        />
      }
    >
      <CourseIconRenderer
        iconSlot={iconSlot}
        legacyIconKey={legacyIconKey}
        className={className}
        {...fontAwesomeProps}
      />
    </Suspense>
  );
}
